import styles from "./Backdrop.module.scss";

export const Backdrop = () => <div className={styles.backdrop} />;
